export default __webpack_public_path__ + "static/media/orange-tick.80201b6a.svg";